export default class KillPigConfigVO {
    public OpenKillPig: boolean = false;
    /**
     * 头部保留轮
     */
    public HeaderReserveJuNumber: number = 1;
    /**
     * 搜索索引
     */
    public SearchStartIndex: number = 0;
    /**
     * 忽略轮
     */
    public IgnoreJuNumber: number = 1;
    /**
     * 尾部保留轮
     */
    public EndReserveJuNumber: number = 2;
    /**
     * 多少钱开始启用
     * 0不限制
     */
    public KillStartAmount: number = 0;
    /**
     * 主播搜索启动范围(默认1)
     */
    public DealerSearchStartRange: number = 1;
    /**
     * 新批次不干预
     */
    public SkipKillInNewGame: boolean = true;

    /**
     * 自动下注（真实下注）总开关，默认关闭；由遥控器“服务配置-保存”在内存中开启，重启后回到关闭
     */
    public AutoBetEnabled: boolean = false;
    /**
     * 自动下注间隔（分钟），默认 8
     */
    public AutoBetIntervalMin: number = 8;
    /**
     * 自动下注单注金额（庄或闲单边），默认 100
     */
    public AutoBetAmount: number = 100;

    /**
     * 真实服务器账号余额（来自自动下注连接的 onUserInfo，实时刷新），仅供遥控器展示
     */
    public RealServerBalance: number = 0;
}